import React, { Component } from 'react';
import {Col,Row} from 'react-bootstrap';
import Item from './Item';

class StorageContainer extends Component {

    render() {
        if (this.props.items !== undefined) {
            return (
                <Col>
                    <Row>
                        {this.props.items.map(i => 
                            <Item item={i} />
                        )}
                    </Row>
                </Col>
            );
        } else {
            return <div>No items found.</div>
        }
    };
}

export default StorageContainer;